import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import story from "../../assets/svg/story.svg";
import Avatar from "../../components/Avatar/Avatar";

const StoryItem = ({ data }) => {
	const navigate = useNavigate();
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
	const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth < 700);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
			setIsSmallMobile(window.innerWidth < 700);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div className={`${styles["slide-wrapper"]} ${styles.storyItemWrapper}`} onDragStart={(e) => e.preventDefault()} >
			<div

				className={styles["slider-item"]}
				onDragStart={(e) => e.preventDefault()}
				onDragEnd={(e) => e.preventDefault()}
				onClick={() => navigate(`/Story/${data?.userId?._id}`, { state: { own: false } })}>
				{(() => {
					const firstStory = data?.stories?.[0];
					const mediaUrl = firstStory?.mediaUrl;
					const resolvedUrl = Array.isArray(mediaUrl) 
						? (typeof mediaUrl[0] === 'string' ? mediaUrl[0] : mediaUrl[0]?.url) 
						: (typeof mediaUrl === 'object' ? mediaUrl?.url : mediaUrl);
					
					return (
						<div 
							className={styles.storyMask}
							style={{
								WebkitMaskImage: `url(${story})`,
								maskImage: `url(${story})`,
							}}
						>
							<img
								src={resolvedUrl || data?.userId?.ProfilePic}
								alt=""
								className={styles.storyImage}
								style={{
									WebkitMaskImage: `url(${story})`,
									maskImage: `url(${story})`,
								}}
								onError={(e) => { e.target.src = data?.userId?.ProfilePic; }}
							/>
						</div>
					);
				})()}
				<div className={styles.ProfilePic}>
					<Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
				</div>
				{/* {!data?.stories[0]?.mediaType === "image" && (
					<img
						src={data?.userId?.ProfilePic} // The mediaUrl will be the content inside the mask
						alt=""
						className={styles.storyImage}
						style={{
							width: "11rem",
							// height: "100%",
							WebkitMaskImage: `url(${story})`, // Use the story SVG as the mask shape
							maskImage: `url(${story})`, // Standard mask-image for cross-browser support
							WebkitMaskRepeat: "no-repeat", // Ensure the mask does not repeat
							maskRepeat: "no-repeat",
							WebkitMaskSize: "contain", // Scale the mask to fit the container
							maskSize: "contain",
							WebkitMaskPosition: "center", // Center the mask
							maskPosition: "center",
							objectFit: "contain",
						}}
					/>
				)} */}
				<span className={styles.title}>@{data?.userId?.username}</span>
			</div>
		</div>
	);
};

export default StoryItem;


